/* eslint-disable no-plusplus */
import { IMacro, IMacros } from "features/editor/types";
import { createImageWithNumber } from "./imageWithNumber";

class TabEditor extends HTMLParagraphElement {}
customElements.define("tab-t", TabEditor, { extends: "span" });

const macroRegex = /(~|\{.*?\}|<(?!br\s*\/|tab\s*\/).*?>)/g;

/**
 * Creates a macro element based on the given macro object.
 * @param macro - The macro object.
 * @returns The created macro element.
 */
export const makeMacroElement = (macro: IMacro) => {
  const span = document.createElement("span");
  span.className = `macro${macro.isExtra ? " macro--extra" : ""}`;
  span.contentEditable = "false";
  // span.draggable = true;  // Issue with delete on  Quests / English / Collections   Collection_Wood_3/Collection_Wood_3 : n1.cd.c
  span.dataset.macroIndex = macro.index.toString();
  span.innerText = macro.value;

  const img = createImageWithNumber(macro.index);
  span.prepend(img!);

  return span;
};

// https://trello.com/c/Oco3YiMG/194-%D0%BF%D0%BE%D1%81%D0%BB%D0%B5-%D0%B7%D0%BD%D0%B0%D0%BA%D0%B0-%D0%B2-%D1%81%D1%82%D1%80%D0%BE%D0%BA%D0%B5-%D0%BF%D0%B5%D1%80%D0%B5%D0%B2%D0%BE%D0%B4%D0%BE%D0%B2-%D1%83%D0%B4%D0%B0%D0%BB%D1%8F%D0%B5%D1%82%D1%81%D1%8F-%D1%81%D0%BA%D1%80%D1%8B%D0%B2%D0%B0%D0%B5%D1%82%D1%81%D1%8F-%D1%82%D0%B5%D0%BA%D1%81%D1%82
// При парсинге текста со знаком «меньше» и буквой («<X») React удаляет последующую часть, так как не может дальше строить валидный Virtual DOM. Поэтому одиночные знаки нужно эскейпить.
const sanitizeText = (text: string): string =>
  text.replace(
    /(<[^>]+>)|</g,
    (match, tagGroup) =>
      // If we captured a tag, return it as is;
      // otherwise, replace the single '<' with '&lt;'
      tagGroup || "&lt;",
  );

// https://trello.com/c/uyzwDFaK/138-%D0%B4%D0%BE%D1%80%D0%B0%D0%B1%D0%BE%D1%82%D0%BA%D0%B0-%D0%BC%D0%B0%D0%BA%D1%80%D0%BE%D1%81%D0%BE%D0%B2
// Нужно добавить проверку что если внутри макроса <text> встречается символы < то ошибка Нужно добавить проверку что если внутри макроса {text} встречается символ { то ошибка Проверять в переводах, ошибку выводить в общий список ошибок  Если кривой макрос в русском языке, то строку будет невозможно апрувнуть, пока не поменяют русский текст и не пересинхронизируют проект. Это нормально
export const isMacroInvalid = (macro: string) => {
  const firstChar = macro[0];

  return Boolean(["<", "{"].includes(firstChar) && macro.includes(firstChar, 1));
};

export const processOriginalTextToHtml = (originalText: string): [IMacros, string] => {
  const macros: IMacros = new Map();
  let index = 0;

  const sanitized = sanitizeText(originalText);

  const html = sanitized.replace(macroRegex, (match: any) => {
    const macro = macros.get(match);
    let data: IMacro;

    if (macro) {
      data = {
        ...macro,
        total: macro.total + 1,
      };
    } else {
      index++;

      data = {
        index,
        value: match,
        total: 1,
      };
    }

    if (isMacroInvalid(match)) {
      data.isExtra = true;
    }

    macros.set(match, data);

    const element = makeMacroElement(data);

    return element.outerHTML;
  });

  return [macros, html];
};

export const processEditorTextToHtml = (text: string, originalMacros: IMacros): string => {
  const macros: IMacros = new Map();
  let index = originalMacros.size;

  const sanitized = sanitizeText(text);

  const html = sanitized.replace(macroRegex, (match: any) => {
    const macro = macros.get(match);
    let data: IMacro;

    if (macro) {
      data = {
        ...macro,
        total: macro.total + 1,
      };
    } else {
      let originalIndex = originalMacros.get(match)?.index;

      if (!originalIndex) {
        index++;
        originalIndex = index;
      }

      data = {
        index: originalIndex,
        value: match,
        total: 1,
      };
    }

    const originalMacro = originalMacros.get(match);

    if (!originalMacro || originalMacro?.total < data.total || isMacroInvalid(match)) {
      data.isExtra = true;
    }

    macros.set(match, data);

    const element = makeMacroElement(data);

    return element.outerHTML;
  });

  return html;
};

export const getMacrosList = (text: string) => {
  const list: string[] = [];

  text.match(macroRegex)?.forEach((match: any) => {
    list.push(match);
  });

  return list;
};

export const areMacrosListsIdentical = (arr1: string[], arr2: string[]) => {
  if (arr1.length !== arr2.length) return false;

  // Convert objects to JSON strings
  const sortedArray1 = arr1.map(obj => JSON.stringify(obj)).sort();
  const sortedArray2 = arr2.map(obj => JSON.stringify(obj)).sort();

  // Compare the sorted arrays
  for (let i = 0; i < sortedArray1.length; i++) {
    if (sortedArray1[i] !== sortedArray2[i]) {
      return false;
    }
  }

  return true;
};

//  Remove \n, \t, \r from the end of the string.
export const cleanTail = (str: string): string => str.replace(/[\n\t\r]+$/, "");

export const getActiveItemTextarea = () =>
  document.getElementsByClassName("editor__content--active")?.[0] as HTMLElement;
